import { ReactNode } from 'react'
import { components, GroupBase, MenuListProps } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { SelectOption } from '../../AstraSelect'

export type AstraMultiSelectMenuListProps<T> = MenuListProps<SelectOption<T>, true, GroupBase<SelectOption<T>>> & {
    title?: ReactNode
    size: SizeOptions
}

export const AstraMultiSelectMenuList = <T,>({ title, size, children, ...rest }: AstraMultiSelectMenuListProps<T>) => (
    <components.MenuList {...rest}>
        {title && (
            <div className="sticky top-0 bg-surface-base px-2 py-1">
                <AstraParagraph variant={size === 'small' ? 'body-small' : 'body'} weight="medium" className="text-subtle">
                    {title}
                </AstraParagraph>
            </div>
        )}
        {children}
    </components.MenuList>
)
